// External
import React from 'react';
import { object, func } from 'prop-types';
import { Box, Flex } from 'rebass';
import { Plus } from '@nike/nike-design-system-icons';
import { connect } from 'react-redux';

import CatalogTypeBadge from '../../catalogTypes/CatalogTypeBadge';

import { saveAdminDepartmentCatalogTypes as saveCatalogTypes } from '../actions';

const CatalogTypeTableCell = ({
  department,
  setSelectedDepartments,
  setSelectedCatalogType,
  openAddCatalogTypeModal,
  openRemoveCatalogTypeModal
}) => {
  const disassociateCatalogTypeClick = catalogType => {
    setSelectedCatalogType(catalogType);
    setSelectedDepartments([department]);
    openRemoveCatalogTypeModal();
  };

  const handleAddCatalogTypeClick = () => {
    setSelectedDepartments([department]);
    openAddCatalogTypeModal();
  };

  return (
    <>
      <Box height='100%' width='100%' style={{ overflowY: 'scroll' }}>
        <Flex width='100%'>
          <Flex width='100%' flexWrap='wrap'>
            {department.catalogTypes?.map(catalogType => (
              <CatalogTypeBadge
                key={catalogType.id}
                catalogType={catalogType}
                disassociateCatalogType={disassociateCatalogTypeClick}
                width='30%'
              />
            ))}
          </Flex>

          <Box mr='5px' onClick={handleAddCatalogTypeClick} style={{ cursor: 'pointer' }}>
            <Plus size='m' data-testid='addCatalogType' />
          </Box>
        </Flex>
      </Box>
    </>
  );
};

CatalogTypeTableCell.defaultProps = {
  department: {}
};

CatalogTypeTableCell.propTypes = {
  department: object,
  setSelectedDepartments: func.isRequired,
  setSelectedCatalogType: func.isRequired,
  openRemoveCatalogTypeModal: func.isRequired,
  openAddCatalogTypeModal: func.isRequired
};

export default connect(null, { saveCatalogTypes })(CatalogTypeTableCell);
